import request from './request';

export const postApi = {
    // 获取帖子列表
    getPosts(params) {
        return request.get('/posts', { params });
    },

    // 获取单个帖子详情
    getPost(id) {
        return request.get(`/posts/${id}`);
    },

    // 创建帖子
    createPost(data) {
        return request.post('/posts', data);
    },

    // 更新帖子
    updatePost(id, data) {
        return request.patch(`/posts/${id}`, data);
    },

    // 点赞/取消点赞帖子
    toggleLike(id) {
        return request.post(`/posts/${id}/like`);
    },

    // 获取帖子评论
    getComments(postId, params) {
        return request.get(`/posts/${postId}/comments`, { params });
    },

    // 创建评论
    createComment(postId, data) {
        return request.post(`/posts/${postId}/comments`, data);
    },

    // 删除评论
    deleteComment(postId, commentId) {
        return request.delete(`/posts/${postId}/comments/${commentId}`);
    },

    // 点赞/取消点赞评论
    toggleCommentLike(postId, commentId) {
        return request.post(`/posts/${postId}/comments/${commentId}/like`);
    },
}; 
